import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import MuiOutlinedInput from '@mui/material/OutlinedInput';
/**
 * @public
 */
var Input = forwardRef(function (_a, ref) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement(MuiOutlinedInput, __assign({ size: size, margin: size === 'small' ? 'dense' : 'none' }, props, { ref: ref })));
});
// @ts-expect-error https://material-ui.com/guides/composition/#wrapping-components
Input.muiName = MuiOutlinedInput.muiName;
export default Input;
/** @private @internal for docs only! */
export var DocsInput = function (props) { return React.createElement(Input, __assign({}, props)); };
//# sourceMappingURL=Input.js.map